export const carYearsData = [
  { id: 1, label: "2000", value: "2000" },
  { id: 2, label: "2001", value: "2001" },
  { id: 3, label: "2002", value: "2002" },
  { id: 4, label: "2003", value: "2003" },
  { id: 5, label: "2004", value: "2004" },
  { id: 6, label: "2005", value: "2005" },
  { id: 7, label: "2006", value: "2006" },
  { id: 8, label: "2007", value: "2007" },
  { id: 9, label: "2008", value: "2008" },
  { id: 10, label: "2009", value: "2009" },
  { id: 11, label: "2010", value: "2010" },
  { id: 12, label: "2011", value: "2011" },
  { id: 13, label: "2012", value: "2012" },
  { id: 14, label: "2013", value: "2013" },
  { id: 15, label: "2014", value: "2014" },
  { id: 16, label: "2015", value: "2015" },
  { id: 17, label: "2016", value: "2016" },
  { id: 18, label: "2017", value: "2017" },
  { id: 19, label: "2018", value: "2018" },
  { id: 20, label: "2019", value: "2019" },
  { id: 21, label: "2020", value: "2020" },
  { id: 22, label: "2021", value: "2021" },
  { id: 23, label: "2022", value: "2022" },
  { id: 24, label: "2023", value: "2023" },
  { id: 25, label: "2024", value: "2024" },
  { id: 26, label: "2025", value: "2025" },
];

export const colors = [
  { id: 1, label: "Red", value: "red" },
  { id: 2, label: "Blue", value: "blue" },
  { id: 3, label: "Green", value: "green" },
  { id: 4, label: "Yellow", value: "yellow" },
  { id: 5, label: "Black", value: "black" },
  { id: 6, label: "White", value: "white" },
  { id: 7, label: "Orange", value: "orange" },
  { id: 8, label: "Purple", value: "purple" },
  { id: 9, label: "Pink", value: "pink" },
  { id: 10, label: "Gray", value: "gray" },
  { id: 11, label: "Brown", value: "brown" },
];

export const countryCodes = [
  {
    code: "+93",
    label: "Afghanistan",
    flag: "https://flagcdn.com/w320/af.png",
  },
  { code: "+355", label: "Albania", flag: "https://flagcdn.com/w320/al.png" },
  { code: "+213", label: "Algeria", flag: "https://flagcdn.com/w320/dz.png" },
  { code: "+376", label: "Andorra", flag: "https://flagcdn.com/w320/ad.png" },
  { code: "+244", label: "Angola", flag: "https://flagcdn.com/w320/ao.png" },
  {
    code: "+1-268",
    label: "Antigua and Barbuda",
    flag: "https://flagcdn.com/w320/ag.png",
  },
  { code: "+54", label: "Argentina", flag: "https://flagcdn.com/w320/ar.png" },
  { code: "+374", label: "Armenia", flag: "https://flagcdn.com/w320/am.png" },
  { code: "+61", label: "Australia", flag: "https://flagcdn.com/w320/au.png" },
  { code: "+43", label: "Austria", flag: "https://flagcdn.com/w320/at.png" },
  {
    code: "+994",
    label: "Azerbaijan",
    flag: "https://flagcdn.com/w320/az.png",
  },
  { code: "+1-242", label: "Bahamas", flag: "https://flagcdn.com/w320/bs.png" },
  { code: "+973", label: "Bahrain", flag: "https://flagcdn.com/w320/bh.png" },
  {
    code: "+880",
    label: "Bangladesh",
    flag: "https://flagcdn.com/w320/bd.png",
  },
  {
    code: "+1-246",
    label: "Barbados",
    flag: "https://flagcdn.com/w320/bb.png",
  },
  { code: "+375", label: "Belarus", flag: "https://flagcdn.com/w320/by.png" },
  { code: "+32", label: "Belgium", flag: "https://flagcdn.com/w320/be.png" },
  { code: "+501", label: "Belize", flag: "https://flagcdn.com/w320/bz.png" },
  { code: "+229", label: "Benin", flag: "https://flagcdn.com/w320/bj.png" },
  { code: "+975", label: "Bhutan", flag: "https://flagcdn.com/w320/bt.png" },
  { code: "+591", label: "Bolivia", flag: "https://flagcdn.com/w320/bo.png" },
  {
    code: "+387",
    label: "Bosnia and Herzegovina",
    flag: "https://flagcdn.com/w320/ba.png",
  },
  { code: "+267", label: "Botswana", flag: "https://flagcdn.com/w320/bw.png" },
  { code: "+55", label: "Brazil", flag: "https://flagcdn.com/w320/br.png" },
  { code: "+673", label: "Brunei", flag: "https://flagcdn.com/w320/bn.png" },
  { code: "+359", label: "Bulgaria", flag: "https://flagcdn.com/w320/bg.png" },
  {
    code: "+226",
    label: "Burkina Faso",
    flag: "https://flagcdn.com/w320/bf.png",
  },
  { code: "+257", label: "Burundi", flag: "https://flagcdn.com/w320/bi.png" },
  { code: "+855", label: "Cambodia", flag: "https://flagcdn.com/w320/kh.png" },
  { code: "+237", label: "Cameroon", flag: "https://flagcdn.com/w320/cm.png" },
  { code: "+1", label: "Canada", flag: "https://flagcdn.com/w320/ca.png" },
  {
    code: "+238",
    label: "Cape Verde",
    flag: "https://flagcdn.com/w320/cv.png",
  },
  {
    code: "+236",
    label: "Central African Republic",
    flag: "https://flagcdn.com/w320/cf.png",
  },
  { code: "+235", label: "Chad", flag: "https://flagcdn.com/w320/td.png" },
  { code: "+56", label: "Chile", flag: "https://flagcdn.com/w320/cl.png" },
  { code: "+86", label: "China", flag: "https://flagcdn.com/w320/cn.png" },
  { code: "+57", label: "Colombia", flag: "https://flagcdn.com/w320/co.png" },
  { code: "+269", label: "Comoros", flag: "https://flagcdn.com/w320/km.png" },
  {
    code: "+243",
    label: "Congo (DRC)",
    flag: "https://flagcdn.com/w320/cd.png",
  },
  {
    code: "+242",
    label: "Congo (Republic)",
    flag: "https://flagcdn.com/w320/cg.png",
  },
  {
    code: "+506",
    label: "Costa Rica",
    flag: "https://flagcdn.com/w320/cr.png",
  },
  { code: "+385", label: "Croatia", flag: "https://flagcdn.com/w320/hr.png" },
  { code: "+53", label: "Cuba", flag: "https://flagcdn.com/w320/cu.png" },
  { code: "+357", label: "Cyprus", flag: "https://flagcdn.com/w320/cy.png" },
  {
    code: "+420",
    label: "Czech Republic",
    flag: "https://flagcdn.com/w320/cz.png",
  },
  { code: "+45", label: "Denmark", flag: "https://flagcdn.com/w320/dk.png" },
  { code: "+253", label: "Djibouti", flag: "https://flagcdn.com/w320/dj.png" },
  {
    code: "+1-767",
    label: "Dominica",
    flag: "https://flagcdn.com/w320/dm.png",
  },
  {
    code: "+1-809",
    label: "Dominican Republic",
    flag: "https://flagcdn.com/w320/do.png",
  },
  { code: "+593", label: "Ecuador", flag: "https://flagcdn.com/w320/ec.png" },
  { code: "+20", label: "Egypt", flag: "https://flagcdn.com/w320/eg.png" },
  {
    code: "+503",
    label: "El Salvador",
    flag: "https://flagcdn.com/w320/sv.png",
  },
  {
    code: "+240",
    label: "Equatorial Guinea",
    flag: "https://flagcdn.com/w320/gq.png",
  },
  { code: "+291", label: "Eritrea", flag: "https://flagcdn.com/w320/er.png" },
  { code: "+372", label: "Estonia", flag: "https://flagcdn.com/w320/ee.png" },
  { code: "+251", label: "Ethiopia", flag: "https://flagcdn.com/w320/et.png" },
  { code: "+679", label: "Fiji", flag: "https://flagcdn.com/w320/fj.png" },
  { code: "+358", label: "Finland", flag: "https://flagcdn.com/w320/fi.png" },
  { code: "+33", label: "France", flag: "https://flagcdn.com/w320/fr.png" },
  { code: "+241", label: "Gabon", flag: "https://flagcdn.com/w320/ga.png" },
  { code: "+220", label: "Gambia", flag: "https://flagcdn.com/w320/gm.png" },
  { code: "+995", label: "Georgia", flag: "https://flagcdn.com/w320/ge.png" },
  { code: "+49", label: "Germany", flag: "https://flagcdn.com/w320/de.png" },
  { code: "+233", label: "Ghana", flag: "https://flagcdn.com/w320/gh.png" },
  { code: "+30", label: "Greece", flag: "https://flagcdn.com/w320/gr.png" },
  { code: "+1-473", label: "Grenada", flag: "https://flagcdn.com/w320/gd.png" },
  { code: "+502", label: "Guatemala", flag: "https://flagcdn.com/w320/gt.png" },
  { code: "+224", label: "Guinea", flag: "https://flagcdn.com/w320/gn.png" },
  {
    code: "+245",
    label: "Guinea-Bissau",
    flag: "https://flagcdn.com/w320/gw.png",
  },
  { code: "+592", label: "Guyana", flag: "https://flagcdn.com/w320/gy.png" },
  { code: "+509", label: "Haiti", flag: "https://flagcdn.com/w320/ht.png" },
  { code: "+504", label: "Honduras", flag: "https://flagcdn.com/w320/hn.png" },
  { code: "+36", label: "Hungary", flag: "https://flagcdn.com/w320/hu.png" },
  { code: "+354", label: "Iceland", flag: "https://flagcdn.com/w320/is.png" },
  { code: "+91", label: "India", flag: "https://flagcdn.com/w320/in.png" },
  { code: "+62", label: "Indonesia", flag: "https://flagcdn.com/w320/id.png" },
  { code: "+98", label: "Iran", flag: "https://flagcdn.com/w320/ir.png" },
  { code: "+964", label: "Iraq", flag: "https://flagcdn.com/w320/iq.png" },
  { code: "+353", label: "Ireland", flag: "https://flagcdn.com/w320/ie.png" },
  { code: "+972", label: "Israel", flag: "https://flagcdn.com/w320/il.png" },
  { code: "+39", label: "Italy", flag: "https://flagcdn.com/w320/it.png" },
  { code: "+1-876", label: "Jamaica", flag: "https://flagcdn.com/w320/jm.png" },
  { code: "+81", label: "Japan", flag: "https://flagcdn.com/w320/jp.png" },
  { code: "+962", label: "Jordan", flag: "https://flagcdn.com/w320/jo.png" },
  { code: "+7", label: "Kazakhstan", flag: "https://flagcdn.com/w320/kz.png" },
  { code: "+254", label: "Kenya", flag: "https://flagcdn.com/w320/ke.png" },
  { code: "+686", label: "Kiribati", flag: "https://flagcdn.com/w320/ki.png" },
  {
    code: "+850",
    label: "North Korea",
    flag: "https://flagcdn.com/w320/kp.png",
  },
  {
    code: "+82",
    label: "South Korea",
    flag: "https://flagcdn.com/w320/kr.png",
  },
  { code: "+965", label: "Kuwait", flag: "https://flagcdn.com/w320/kw.png" },
  {
    code: "+996",
    label: "Kyrgyzstan",
    flag: "https://flagcdn.com/w320/kg.png",
  },
  { code: "+856", label: "Laos", flag: "https://flagcdn.com/w320/la.png" },
  { code: "+371", label: "Latvia", flag: "https://flagcdn.com/w320/lv.png" },
  { code: "+961", label: "Lebanon", flag: "https://flagcdn.com/w320/lb.png" },
  { code: "+266", label: "Lesotho", flag: "https://flagcdn.com/w320/ls.png" },
  { code: "+231", label: "Liberia", flag: "https://flagcdn.com/w320/lr.png" },
  { code: "+218", label: "Libya", flag: "https://flagcdn.com/w320/ly.png" },
  {
    code: "+423",
    label: "Liechtenstein",
    flag: "https://flagcdn.com/w320/li.png",
  },
  { code: "+370", label: "Lithuania", flag: "https://flagcdn.com/w320/lt.png" },
  {
    code: "+352",
    label: "Luxembourg",
    flag: "https://flagcdn.com/w320/lu.png",
  },
  {
    code: "+261",
    label: "Madagascar",
    flag: "https://flagcdn.com/w320/mg.png",
  },
  { code: "+265", label: "Malawi", flag: "https://flagcdn.com/w320/mw.png" },
  { code: "+60", label: "Malaysia", flag: "https://flagcdn.com/w320/my.png" },
  { code: "+960", label: "Maldives", flag: "https://flagcdn.com/w320/mv.png" },
  { code: "+223", label: "Mali", flag: "https://flagcdn.com/w320/ml.png" },
  { code: "+356", label: "Malta", flag: "https://flagcdn.com/w320/mt.png" },
  {
    code: "+692",
    label: "Marshall Islands",
    flag: "https://flagcdn.com/w320/mh.png",
  },
  {
    code: "+222",
    label: "Mauritania",
    flag: "https://flagcdn.com/w320/mr.png",
  },
  { code: "+230", label: "Mauritius", flag: "https://flagcdn.com/w320/mu.png" },
  { code: "+52", label: "Mexico", flag: "https://flagcdn.com/w320/mx.png" },
  {
    code: "+691",
    label: "Micronesia",
    flag: "https://flagcdn.com/w320/fm.png",
  },
  { code: "+373", label: "Moldova", flag: "https://flagcdn.com/w320/md.png" },
  { code: "+377", label: "Monaco", flag: "https://flagcdn.com/w320/mc.png" },
  { code: "+976", label: "Mongolia", flag: "https://flagcdn.com/w320/mn.png" },
  {
    code: "+382",
    label: "Montenegro",
    flag: "https://flagcdn.com/w320/me.png",
  },
  { code: "+212", label: "Morocco", flag: "https://flagcdn.com/w320/ma.png" },
  {
    code: "+258",
    label: "Mozambique",
    flag: "https://flagcdn.com/w320/mz.png",
  },
  { code: "+95", label: "Myanmar", flag: "https://flagcdn.com/w320/mm.png" },
  { code: "+264", label: "Namibia", flag: "https://flagcdn.com/w320/na.png" },
  { code: "+674", label: "Nauru", flag: "https://flagcdn.com/w320/nr.png" },
  { code: "+977", label: "Nepal", flag: "https://flagcdn.com/w320/np.png" },
  {
    code: "+31",
    label: "Netherlands",
    flag: "https://flagcdn.com/w320/nl.png",
  },
  {
    code: "+687",
    label: "New Caledonia",
    flag: "https://flagcdn.com/w320/nc.png",
  },
  {
    code: "+64",
    label: "New Zealand",
    flag: "https://flagcdn.com/w320/nz.png",
  },
  { code: "+505", label: "Nicaragua", flag: "https://flagcdn.com/w320/ni.png" },
  { code: "+227", label: "Niger", flag: "https://flagcdn.com/w320/ne.png" },
  { code: "+234", label: "Nigeria", flag: "https://flagcdn.com/w320/ng.png" },
  {
    code: "+389",
    label: "North Macedonia",
    flag: "https://flagcdn.com/w320/mk.png",
  },
  { code: "+47", label: "Norway", flag: "https://flagcdn.com/w320/no.png" },
  { code: "+968", label: "Oman", flag: "https://flagcdn.com/w320/om.png" },
  { code: "+92", label: "Pakistan", flag: "https://flagcdn.com/w320/pk.png" },
  { code: "+680", label: "Palau", flag: "https://flagcdn.com/w320/pw.png" },
  { code: "+970", label: "Palestine", flag: "https://flagcdn.com/w320/ps.png" },
  { code: "+507", label: "Panama", flag: "https://flagcdn.com/w320/pa.png" },
  {
    code: "+675",
    label: "Papua New Guinea",
    flag: "https://flagcdn.com/w320/pg.png",
  },
  { code: "+595", label: "Paraguay", flag: "https://flagcdn.com/w320/py.png" },
  { code: "+51", label: "Peru", flag: "https://flagcdn.com/w320/pe.png" },
  {
    code: "+63",
    label: "Philippines",
    flag: "https://flagcdn.com/w320/ph.png",
  },
  { code: "+48", label: "Poland", flag: "https://flagcdn.com/w320/pl.png" },
  { code: "+351", label: "Portugal", flag: "https://flagcdn.com/w320/pt.png" },
  { code: "+974", label: "Qatar", flag: "https://flagcdn.com/w320/qa.png" },
  { code: "+40", label: "Romania", flag: "https://flagcdn.com/w320/ro.png" },
  { code: "+7", label: "Russia", flag: "https://flagcdn.com/w320/ru.png" },
  { code: "+250", label: "Rwanda", flag: "https://flagcdn.com/w320/rw.png" },
  { code: "+685", label: "Samoa", flag: "https://flagcdn.com/w320/ws.png" },
  {
    code: "+378",
    label: "San Marino",
    flag: "https://flagcdn.com/w320/sm.png",
  },
  {
    code: "+239",
    label: "Sao Tome and Principe",
    flag: "https://flagcdn.com/w320/st.png",
  },
  {
    code: "+966",
    label: "Saudi Arabia",
    flag: "https://flagcdn.com/w320/sa.png",
  },
  { code: "+221", label: "Senegal", flag: "https://flagcdn.com/w320/sn.png" },
  { code: "+381", label: "Serbia", flag: "https://flagcdn.com/w320/rs.png" },
  {
    code: "+248",
    label: "Seychelles",
    flag: "https://flagcdn.com/w320/sc.png",
  },
  {
    code: "+232",
    label: "Sierra Leone",
    flag: "https://flagcdn.com/w320/sl.png",
  },
  { code: "+65", label: "Singapore", flag: "https://flagcdn.com/w320/sg.png" },
  { code: "+421", label: "Slovakia", flag: "https://flagcdn.com/w320/sk.png" },
  { code: "+386", label: "Slovenia", flag: "https://flagcdn.com/w320/si.png" },
  {
    code: "+677",
    label: "Solomon Islands",
    flag: "https://flagcdn.com/w320/sb.png",
  },
  { code: "+252", label: "Somalia", flag: "https://flagcdn.com/w320/so.png" },
  {
    code: "+27",
    label: "South Africa",
    flag: "https://flagcdn.com/w320/za.png",
  },
  {
    code: "+211",
    label: "South Sudan",
    flag: "https://flagcdn.com/w320/ss.png",
  },
  { code: "+34", label: "Spain", flag: "https://flagcdn.com/w320/es.png" },
  { code: "+94", label: "Sri Lanka", flag: "https://flagcdn.com/w320/lk.png" },
  { code: "+249", label: "Sudan", flag: "https://flagcdn.com/w320/sd.png" },
  { code: "+597", label: "Suriname", flag: "https://flagcdn.com/w320/sr.png" },
  { code: "+46", label: "Sweden", flag: "https://flagcdn.com/w320/se.png" },
  {
    code: "+41",
    label: "Switzerland",
    flag: "https://flagcdn.com/w320/ch.png",
  },
  { code: "+963", label: "Syria", flag: "https://flagcdn.com/w320/sy.png" },
  { code: "+886", label: "Taiwan", flag: "https://flagcdn.com/w320/tw.png" },
  {
    code: "+992",
    label: "Tajikistan",
    flag: "https://flagcdn.com/w320/tj.png",
  },
  { code: "+255", label: "Tanzania", flag: "https://flagcdn.com/w320/tz.png" },
  { code: "+66", label: "Thailand", flag: "https://flagcdn.com/w320/th.png" },
  { code: "+228", label: "Togo", flag: "https://flagcdn.com/w320/tg.png" },
  { code: "+676", label: "Tonga", flag: "https://flagcdn.com/w320/to.png" },
  {
    code: "+1-868",
    label: "Trinidad and Tobago",
    flag: "https://flagcdn.com/w320/tt.png",
  },
  { code: "+216", label: "Tunisia", flag: "https://flagcdn.com/w320/tn.png" },
  { code: "+90", label: "Turkey", flag: "https://flagcdn.com/w320/tr.png" },
  {
    code: "+993",
    label: "Turkmenistan",
    flag: "https://flagcdn.com/w320/tm.png",
  },
  { code: "+688", label: "Tuvalu", flag: "https://flagcdn.com/w320/tv.png" },
  { code: "+256", label: "Uganda", flag: "https://flagcdn.com/w320/ug.png" },
  { code: "+380", label: "Ukraine", flag: "https://flagcdn.com/w320/ua.png" },
  {
    code: "+971",
    label: "United Arab Emirates",
    flag: "https://flagcdn.com/w320/ae.png",
  },
  {
    code: "+44",
    label: "United Kingdom",
    flag: "https://flagcdn.com/w320/gb.png",
  },
  {
    code: "+1",
    label: "United States",
    flag: "https://flagcdn.com/w320/us.png",
  },
  { code: "+598", label: "Uruguay", flag: "https://flagcdn.com/w320/uy.png" },
  {
    code: "+998",
    label: "Uzbekistan",
    flag: "https://flagcdn.com/w320/uz.png",
  },
  { code: "+678", label: "Vanuatu", flag: "https://flagcdn.com/w320/vu.png" },
  {
    code: "+379",
    label: "Vatican City",
    flag: "https://flagcdn.com/w320/va.png",
  },
  { code: "+58", label: "Venezuela", flag: "https://flagcdn.com/w320/ve.png" },
  { code: "+84", label: "Vietnam", flag: "https://flagcdn.com/w320/vn.png" },
  { code: "+967", label: "Yemen", flag: "https://flagcdn.com/w320/ye.png" },
  { code: "+260", label: "Zambia", flag: "https://flagcdn.com/w320/zm.png" },
  { code: "+263", label: "Zimbabwe", flag: "https://flagcdn.com/w320/zw.png" },
];
export const genderData = [
  {
    id: 1,
    label: "Male",
    value: "male",
  },
  {
    id: 2,
    label: "Female",
    value: "female",
  },
];

export let socket;

export const musicType = [
  { id: 1, label: "Rock", value: "rock" },
  { id: 2, label: "Pop", value: "pop" },
  { id: 3, label: "Jazz", value: "jazz" },
  { id: 4, label: "Classical", value: "classical" },
  { id: 5, label: "Country", value: "country" },
  { id: 6, label: "Hip-Hop", value: "hip-hop" },
  { id: 7, label: "Electronic", value: "electronic" },
  { id: 8, label: "Other", value: "other" },
];

export const insuranceTypes = [
  {
    id: 1,
    label: "Compulsory Car Insurance",
    value: "Compulsory Car Insurance",
  },
  {
    id: 2,
    label: "Third-Party Liability Insurance",
    value: "Third-Party Liability Insurance",
  },
  { id: 3, label: "All Risk Car Insurance", value: "All Risk Car Insurance" },
];

export const AdditionalCharges = [
  {
    id: 1,
    label: "Kilometer",
    value: "Kilometer",
  },
  {
    id: 2,
    label: "Minutes",
    value: "Minutes",
  },
  { id: 3, label: "Kilogram", value: "Kilogram" },
  { id: 4, label: "Fees", value: "Fees" },
];

export const orderStatus = [
  "requested",
  "request_accepted",
  "to_pickup",
  "arrived_at_pickup",
  "pickup_confirmed",
  "to_destination",
  "arrived_at_destination",
  "completed_from_Driver",
  "completed",
  "cancelled",
  "scheduled",
  "no_response",
];

export const orderScheduledStatus = ["scheduled", "no_response", "unassigned"];

export const TeamTypes = [
  {
    _id: "CEO",
    label: "CEO",
    title: "CEO",
  },
  {
    _id: "Founder",
    label: "Founder",
    title: "Founder",
  },
  { _id: "Team Member", label: "Team Member", title: "Team Member" },
];
